import ScrollContainer from 'react-indiana-drag-scroll';
import Skeleton from 'react-loading-skeleton-2';
import styled, { css } from 'styled-components';

export const Container = styled.main`
  position: relative;
  max-height: calc(100vh - 56px);
  overflow-y: auto !important;

  @media (min-width: 768px) {
    max-height: calc(100vh - 64px);
  }

  .cart {
    position: fixed;
    bottom: 8px;
    z-index: 2;
    right: 50%;
    transform: translateX(50%);
    display: flex;
    background-color: var(--color-blue);
    color: var(--color-gray-900);
    border-radius: 5px;
    cursor: pointer;
    gap: 8px;
    align-items: center;
    padding: 12px;
    width: 90%;

    p {
      flex: 1;
      font-weight: 600;
      white-space: nowrap;
      font-size: 16px;
    }

    p:nth-child(1) {
      text-align: start;
    }

    p:nth-child(2) {
      text-align: center;
    }

    p:nth-child(3) {
      text-align: end;
    }
  }
`;

export const CustomScrollContainer = styled(ScrollContainer)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  margin: 15px 0px 20px;
  max-width: 100%;
  flex: none;
  padding: 0px 24px;

  @media (min-width: 768px) {
    padding: 0px 30px;
  }
`;

export const ContainerProductItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
  padding: 0px 24px 24px;

  @media (min-width: 768px) {
    padding: 0px 30px 30px;
  }

  @media (max-width: 600px) {
    padding: 0px 15px 15px;
    gap: 10px;
  }

  @media (max-width: 450px) {
    padding: 0px 10px 10px;
    gap: 7.5px;
  }

  @media (max-width: 450px) {
    gap: 5px;
  }

  scrollbar-width: thin;
  scrollbar-color: black transparent;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a1a1a1;
    border-radius: 10px;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 182px;
    height: auto;
    border-radius: 5px;
    border: 2px solid var(--color-gray-900);
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    :hover {
      border-color: var(--color-blue-opacity-50);
    }

    > div {
      width: 100%;
      height: 100%;
      padding: 10px 15px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      text-align: center;

      p,
      span {
        font-size: 15px;
        line-height: 19px;
        color: var(--color-navy-blue);

        @media (max-width: 500px) {
          font-size: 12px;
          line-height: 1;
        }

        @media (max-width: 400px) {
          font-size: 10px;
        }
      }

      p:last-child {
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;

        @media (max-width: 400px) {
          font-size: 12px;
          line-height: 1;
        }
      }

      @media (max-width: 500px) {
        padding: 5px 7.5px 10px;
      }
    }

    @media (max-width: 600px) {
      width: 149px;
    }

    @media (max-width: 500px) {
      width: 120px;
    }

    @media (max-width: 400px) {
      width: 105px;
    }
  }

  img {
    width: 100%;
    height: 122px;
    object-position: center;
    object-fit: cover;
  }
`;

export const ContainerItemSelectable = styled.div<{ seleted?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 2px solid var(--color-gray-900);
  ${(p) =>
    p.seleted &&
    css`
      border-color: var(--color-blue);
    `}
  border-radius: 5px;
  height: fit-content;
  transition: all 0.2s ease-in-out;

  :hover {
    border-color: var(--color-blue-opacity-50);
    cursor: pointer;

    p {
      color: var(--color-navy-blue);
    }
  }

  p {
    user-select: none;
    font-size: 11px;
    line-height: 14px;
    white-space: nowrap;
    color: var(--color-gray-800);
    ${(p) =>
      p.seleted &&
      css`
        color: var(--color-navy-blue);
      `}
  }
`;

export const CustomSkeletonItemGroup = styled(Skeleton)`
  height: 42px;
  width: 80px;
  min-width: 80px;
`;

export const CustomSkeletonItemProduct = styled(Skeleton)`
  min-height: 222px;
  height: 222px;
  width: 182px;
  min-width: 182px;
`;
